/**
 * @ Author: Zhang Yujun
 * @ Create Time: 2025-01-23 10:15:55
 * @ Modified by: Zhang Yujun
 * @ Modified time: 2025-02-22 15:51:48
 * @ Description:
 */

import CONFIG from '@/config'
import eventBus from '@/utils/eventBus.js'
export * from './storage'

export function getImgPath (imageUrl, imgNumber) {
  try {
    const imgJson = JSON.parse(imageUrl)
    const path = imgJson[imgNumber]
    if (!path || path.indexOf('http') > -1) {
      return path
    }
    return CONFIG.RESOURCE_PATH + path
  } catch (error) {
    return ''
  }
}
/** 获取JSESSIONID, 记录访问日志的时候要记录它 */
export function getJSESSIONID () {
  const array = new Uint8Array(32)
  window.crypto.getRandomValues(array)
  let result = ''
  const characters = '0123456789abcdef'
  for (let i = 0; i < 32; i++) {
    const value = array[i] % 16
    result += characters[value]
  }
  return result
}
/**
 * 对播放地址中的中文进行编码
 * @param {string} str 播放地址
 * @returns
 */
export function encodeChineseCharacters (str) {
  const chineseRegex = /[\u4e00-\u9fa5]|[^\w/:]/g
  let result = ''
  let index = 0
  let match
  while ((match = chineseRegex.exec(str)) !== null) {
    const start = match.index
    result += str.slice(index, start)
    result += encodeURIComponent(match[0])
    index = start + 1
  }
  result += str.slice(index)
  console.log(result)
  return result
}
/**
 * 根据推荐位的类型, 跳转到播放页并传参
 * @param {object} material 推荐位数据
 */
export function goMP (material) {
  console.log(material)
  if (!this.$store.state.user.userId) {
    goLogin()
    return
  }
  const code = material.objectCode ? material.objectCode : material.code
  // if (material.type === 'contentpkg') {
  //   this.$router.push({
  //     path: '/contentpkgPlayer',
  //     query: { code: code, sourceCode: this.accessCode }
  //   })
  // } else if (material.type === 'content') {
  //   this.$router.push({
  //     path: '/contentPlayer',
  //     query: { code: code, sourceCode: this.accessCode }
  //   })
  // }
  let route
  if (material.type === 'contentpkg') {
    route = this.$router.resolve({
      path: '/contentpkgPlayer',
      query: { code: code, sourceCode: this.$route.query.accessCode || this.$route.meta.accessCode }
    })
  } else if (material.type === 'content') {
    route = this.$router.resolve({
      path: '/contentPlayer',
      query: { code: code, sourceCode: this.$route.query.accessCode || this.$route.meta.accessCode }
    })
  }
  const baseUrl = window.location.origin
  const fullUrl = baseUrl + route.href
  window.open(fullUrl, '_blank')
}
// 传剧集code, 跳到剧集播放页
export function goContentpkgMP (code) {
  if (!this.$store.state.user.userId) {
    goLogin()
    return
  }
  // this.$router.push({
  //   path: '/contentpkgPlayer',
  //   query: { code: code, sourceCode: this.accessCode }
  // })
  const route = this.$router.resolve({
    path: '/contentpkgPlayer',
    query: { code: code, sourceCode: this.$route.query.accessCode || this.$route.meta.accessCode }
  })
  const baseUrl = window.location.origin
  const fullUrl = baseUrl + route.href
  window.open(fullUrl, '_blank')
}
// 传内容code, 跳到内容播放页
export function goContentMP (code) {
  if (!this.$store.state.user.userId) {
    goLogin()
    return
  }
  // this.$router.push({
  //   path: '/contentPlayer',
  //   query: { code: code, sourceCode: this.accessCode }
  // })
  const route = this.$router.resolve({
    path: '/contentPlayer',
    query: { code: code, sourceCode: this.$route.query.accessCode || this.$route.meta.accessCode }
  })
  const baseUrl = window.location.origin
  const fullUrl = baseUrl + route.href
  window.open(fullUrl, '_blank')
}
export function goLogin () {
  window._vm.$alert('请先登录', '您还未登录~', {
    confirmButtonText: '去登录',
    center: true,
    callback: action => {
      if (action === 'confirm') {
        eventBus.emit('showLoginDialog')
      }
    }
  })
}
